import { restrictionMeasureIdFormat } from "@redotech/redo-xborder-outbound-id";
import * as z from "zod";
import { null as zNull } from "zod";

// 404 when the measure isn't one the account has tripped (don't confirm existence).
export const resolveRestrictionMeasure = {
  name: "resolveRestrictionMeasure" as const,
  input: z.object({
    measureId: restrictionMeasureIdFormat.schema,
    note: z.string().min(1).max(2000),
  }),
  output: zNull(),
};

export const unresolveRestrictionMeasure = {
  name: "unresolveRestrictionMeasure" as const,
  input: z.object({ measureId: restrictionMeasureIdFormat.schema }),
  output: zNull(),
};
